import Vue from"vue";Vue.directive("basket-item-sum",{update(e,u){e.innerHTML=Vue.filter("currency").apply(Object,[u.value])}});